import React from 'react'
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import Loading from "components/Loading";
import StatisticsService from "services/StatisticsService";
import Correspondence from "components/complex/correspondence/Correspondence";

function CorrespondenceSection(
    {
        currentRfxRound
    }) {

    return (
        <div>
            {(!currentRfxRound) ?
                <Loading/>
                :
                <Correspondence rfxRound={currentRfxRound}/>
            }
        </div>
    )
}

CorrespondenceSection.propTypes = {
    classes: PropTypes.any,
}

const mapStateToProps = (state) => {
    return {
        currentRfxRound: state.resources[StatisticsService.CURRENT_RFX_RESOURCE_ID]
    }
}
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CorrespondenceSection);